// Gestion de la checkbox "Tout sélectionner" avec état indeterminate
export function initSelectAllCheckbox(container = document) {
  // Trouver tous les groupes avec une checkbox "select-all"
  const selectAllCheckboxes = container.querySelectorAll('[id^="select-all"]');
  
  selectAllCheckboxes.forEach(selectAllCheckbox => {
    // Trouver le groupe parent
    const group = selectAllCheckbox.closest('.checkbox-group');
    if (!group) return;
    
    // Trouver les sous-options dans le groupe nested
    const nestedGroup = group.querySelector('.checkbox-group--nested');
    if (!nestedGroup) return;
    
    const subCheckboxes = nestedGroup.querySelectorAll('.checkbox__input');
    if (subCheckboxes.length === 0) return;
    
    // Fonction pour mettre à jour l'état de "Tout sélectionner"
    function updateSelectAllState() {
      const checkedCount = Array.from(subCheckboxes).filter(cb => cb.checked).length;
      
      if (checkedCount === 0) {
        selectAllCheckbox.checked = false;
        selectAllCheckbox.indeterminate = false;
      } else if (checkedCount === subCheckboxes.length) {
        selectAllCheckbox.checked = true;
        selectAllCheckbox.indeterminate = false;
      } else {
        selectAllCheckbox.checked = false;
        selectAllCheckbox.indeterminate = true;
      }
    }
    
    // Gérer le clic sur "Tout sélectionner"
    selectAllCheckbox.addEventListener('change', () => {
      const isChecked = selectAllCheckbox.checked;
      subCheckboxes.forEach(cb => {
        cb.checked = isChecked;
      });
      selectAllCheckbox.indeterminate = false;
    });
    
    // Gérer les clics sur les sous-options
    subCheckboxes.forEach(cb => {
      cb.addEventListener('change', updateSelectAllState);
    });
    
    // Initialiser l'état au chargement
    updateSelectAllState();
  });
}